import { applyMedicationDefaultsToTarget, getMedicationDefaultsForName } from "@/utils/clientConfig";
export class MedicationDetail {
    medication;
    nationalDrugCode;
    packageSizeUnit;
    name;
    strength;
    routeAdministration;
    constructor(row) {
        this.medication = row.medication || row.label || "";
        this.nationalDrugCode = row.nationalDrugCode || "";
        this.packageSizeUnit = row.packageSizeUnit || "";
        this.name = row.name || "";
        this.strength = row.strength || "";
        this.routeAdministration = row.routeAdministration || "";
    }
    /** Same text as the medication dropdown item. */
    get label() {
        return this.nationalDrugCode ? `${this.medication} [${this.nationalDrugCode}]` : this.medication;
    }
    isAppliedTo(target) {
        return target.medication === this.medication && (target.nationalDrugCode || "") === this.nationalDrugCode;
    }
    /**
     * Write the row onto the target; with `blanksOnly`, a field the user already filled is kept.
     * Every written field is reported through `emitUpdate`, the client defaults included.
     */
    applyTo(target, medicationDefaultsMap, emitUpdate, blanksOnly = false) {
        const isBlank = (field) => target[field] === null || target[field] === undefined || target[field] === "";
        const write = (field, value) => {
            if (blanksOnly && !isBlank(field))
                return;
            target[field] = value;
            emitUpdate(field, value);
        };
        write("medication", this.medication);
        write("packageSizeUnit", this.packageSizeUnit);
        write("nationalDrugCode", this.nationalDrugCode);
        const defaults = getMedicationDefaultsForName(this.name, medicationDefaultsMap ?? {});
        if (!defaults)
            return;
        const applicable = blanksOnly
            ? Object.fromEntries(Object.entries(defaults).filter(([field]) => isBlank(field)))
            : defaults;
        applyMedicationDefaultsToTarget(applicable, target, emitUpdate);
    }
}
